export const parseFloatFromString = (str?: string | null) => {
  if (!str) {
    return 0;
  }
  const cleanedInput = str.replace(/[A-Za-z]+/g, '');
  const regex = /[+-]?(?:\d+)?(?:[.,])?(?:\d+)?/;
  const match = cleanedInput.trim().match(regex);
  return match ? Math.round(parseFloat(match[0].replace(',', '.')) * 100) / 100 : 0;
};
